import { useQuery } from "@tanstack/react-query";

export const useReport = (
    api,
    accountID,
    showID = "ALL",
    report,
    period,
    startDate,
    endDate,
    attributionWindow,
    filters
) => {
    return useQuery({
        queryKey: [
            accountID,
            showID,
            "links",
            "reports",
            report,
            period,
            startDate,
            endDate,
            attributionWindow,
            filters,
        ],
        queryFn: () =>
            api.report({
                accountID,
                showID,
                report,
                period,
                startDate,
                endDate,
                attributionWindow,
                filters,
            }),
    });
};

const periodsQuery = (
    api,
    report,
    accountID,
    showID = "ALL",
    period,
    startDate,
    endDate,
    attributionWindow,
    filters,
    id
) => ({
    queryKey: [
        accountID,
        showID,
        "links",
        "periods",
        report,
        id ?? "total",
        period,
        startDate,
        endDate,
        attributionWindow,
        filters,
    ],
    queryFn: () => api.periods({
        accountID,
        showID,
        report,
        period,
        startDate,
        endDate,
        attributionWindow,
        filters,
        id,
    }),
});

export const usePeriods = (
    api,
    report,
    accountID,
    showID,
    period,
    startDate,
    endDate,
    attributionWindow,
    filters
) => {
    return useQuery(
        periodsQuery(
            api,
            report,
            accountID,
            showID,
            period,
            startDate,
            endDate,
            attributionWindow,
            filters
        )
    );
};